import { AggregationState } from '../types'
import { requestCommon } from 'live/lib/utils'

export async function getStates(
    assetType: string,
    id: string
): Promise<{ success: boolean; states: { [id: string]: AggregationState }; response?: Response }> {
    const r = await fetch(`/services/plugin-asset-aggregator/aggregations/${assetType}/${id}/status`)

    if (r.ok) {
        const json = await r.json()

        return { success: true, states: json }
    } else {
        return { success: false, states: {}, response: r }
    }
}

export async function reprocess(
    assetType: string,
    assetId: string,
    aggregationIds: Set<string>,
    span: string
): Promise<any> {
    const s = encodeURIComponent(span)
    const r = await fetch(
        `/services/plugin-asset-aggregator/aggregations/${assetType}/${assetId}/reprocess?span=${s}`,
        {
            ...requestCommon,
            method: 'POST',
            body: JSON.stringify([...aggregationIds])
        }
    )

    if (!r.ok) {
        const errorString =
            `Error reprocessing aggregation '${aggregationIds}' with span '${span}' for asset with ID '${assetId}' - request status: '${r.statusText}'`

        console.error(
            errorString
        )

        throw new Error(errorString)
    }

    return await r.json()
}

export async function start(
    assetType: string,
    assetId: string,
    aggregationIds: Set<string>,
    fromCheckpoint: boolean
): Promise<any> {
    const r = await fetch(
        `/services/plugin-asset-aggregator/aggregations/${assetType}/${assetId}/start?fromCheckpoint=${fromCheckpoint}`,
        {
            ...requestCommon,
            method: 'POST',
            body: JSON.stringify([...aggregationIds])
        }
    )

    if (!r.ok) {
        const errorString =
            `Error starting aggregation '${aggregationIds}' for asset with ID '${assetId}' - request status: '${r.statusText}'`


        console.error(
            errorString
        )

        throw new Error(errorString)
    }

    return await r.json()
}

export async function startWithTimespan(
    assetType: string,
    assetId: string,
    aggregationIds: Set<string>,
    span: string
): Promise<any> {
    const s = encodeURIComponent(span)
    const r = await fetch(
        `/services/plugin-asset-aggregator/aggregations/${assetType}/${assetId}/start?span=${s}`,
        {
            ...requestCommon,
            method: 'POST',
            body: JSON.stringify([...aggregationIds])
        }
    )

    if (!r.ok) {
        const errorString =
            `Error starting aggregation '${aggregationIds}' for asset with ID '${assetId}' - request status: '${r.statusText}'`


        console.error(
            errorString
        )

        throw new Error(errorString)
    }

    return await r.json()
}

export async function stop(assetType: string, assetId: string, aggregationIds: Set<string>): Promise<void> {
    const r = await fetch(`/services/plugin-asset-aggregator/aggregations/${assetType}/${assetId}/stop`, {
        ...requestCommon,
        method: 'POST',
        body: JSON.stringify([...aggregationIds])
    })

    if (!r.ok) {
        const errorString = `Error stopping aggregation '${aggregationIds}' for asset with ID '${assetId}' - request status: '${r.statusText}'`
        console.error(
            errorString
        )

        throw new Error(errorString)
    }
}

export async function getAssetTypes(): Promise<string[]> {
    const r = await fetch(`/services/plugin-asset-aggregator/aggregations/assetTypes`)
    const json = await r.json()

    return json
}
